<script setup>
import { defineModel } from 'vue';

const dataType = defineModel({ default: null });

const options = [
    { value: 'LEADS', label: 'Лиды' },
    { value: 'DEALS', label: 'Сделки' },
    { value: 'CONTACTS', label: 'Контакты' },
];

function selectType(value) {
    dataType.value = value;
}
</script>

<template>
    <div class="w-full mt-8 sm:mt-10">
        <div class="mb-3 sm:mb-4 font-bold text-base sm:text-lg">
            Тип данных
        </div>
        <div class="flex flex-col sm:flex-row gap-3">
            <button
                v-for="option in options"
                :key="option.value"
                type="button"
                class="flex-1 px-4 py-3 rounded-md border-2 text-sm font-semibold transition-colors duration-150"
                :class="dataType === option.value
                    ? 'border-blue-500 bg-blue-50 text-blue-700'
                    : 'border-blue-200 text-gray-700 hover:bg-blue-50/60'"
                @click="selectType(option.value)"
            >
                {{ option.label }}
            </button>
        </div>
    </div>
</template>
